export default "data:image/gif;base64,R0lGODlhEgAMAPEAAGZmzP//ZuXl5QAAACH5BAAAAAAALAAAAAASAAwAAAIbhI+py+0Pozwi2ItzEFV7y31fKGpkiXHqyrIFADs="